import SectorIndustryLabel from '@/creditflowresearch/ui/common/components/CreditFlowResearch/SectorIndustryLabel';
import { useSectorIndustryData } from './useSectorIndustryData';

import spacesStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';

const SectorIndustryCell = ({ row }) => {
  const { sectorOrIndustry, subsectorOrSubindustry, isLoading } = useSectorIndustryData(row);

  if (isLoading) {
    return null;
  }

  return (
    <SectorIndustryLabel
      sectorOrIndustry={ sectorOrIndustry }
      subsectorOrSubindustry={ subsectorOrSubindustry }
      className={ spacesStyles.mrn }
    />
  );
};

export default SectorIndustryCell;
